export default "__VITE_ASSET__qZSj1FRI__"